/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgRepeatingEvent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.3334 4.30001C8.62019 4.30001 7.07135 4.99317 5.94782 6.11747C5.54216 6.52342 5.09641 7.02898 4.6749 7.53335H7.00007C7.71804 7.53335 8.30007 8.11538 8.30007 8.83335C8.30007 9.55132 7.71804 10.1333 7.00007 10.1333H2.00007C1.2821 10.1333 0.700073 9.55132 0.700073 8.83335V3.83335C0.700073 3.11538 1.2821 2.53335 2.00007 2.53335C2.71804 2.53335 3.30007 3.11538 3.30007 3.83335V5.14429C3.56943 4.84046 3.84312 4.5454 4.10871 4.27963C5.69994 2.6873 7.90261 1.70001 10.3334 1.70001C15.1935 1.70001 19.1334 5.63991 19.1334 10.5C19.1334 15.3601 15.1935 19.3 10.3334 19.3C6.3196 19.3 2.93655 16.6138 1.87751 12.9438C1.67845 12.2539 2.0763 11.5334 2.76612 11.3343C3.45594 11.1353 4.17653 11.5331 4.37558 12.2229C5.12211 14.81 7.50873 16.7 10.3334 16.7C13.7576 16.7 16.5334 13.9242 16.5334 10.5C16.5334 7.07585 13.7576 4.30001 10.3334 4.30001Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgRepeatingEvent
